<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-head">Contents</p>
<p class="toc-front" id="fron-1"><a href="#/BENEATHTHESKIN_fron1">HIGH PRAISE FOR <em><strong>BENEATH THE SKIN</strong></em></a></p>
<p class="toc-front" id="adcard"><span href="#/BENEATHTHESKIN_adcard" title="Link target outside of Sample">Also by Nicci French</span></p>
<p class="toc-front" id="copy"><span href="#/BENEATHTHESKIN_copy" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-part" id="part-1"><a href="#/BENEATHTHESKIN_part1">PART ONE: Zoe</a></p>
<p class="toc-chapter" id="chap-1"><a href="#/BENEATHTHESKIN_chap1">ONE</a></p>
<p class="toc-chapter" id="chap-2"><a href="#/BENEATHTHESKIN_chap2">TWO</a></p>
<p class="toc-chapter" id="chap-3"><a href="#/BENEATHTHESKIN_chap3">THREE</a></p>
<p class="toc-chapter" id="chap-4"><a href="#/BENEATHTHESKIN_chap4">FOUR</a></p>
<p class="toc-chapter" id="chap-5"><a href="#/BENEATHTHESKIN_chap5">FIVE</a></p>
<p class="toc-chapter" id="chap-6"><a href="#/BENEATHTHESKIN_chap6">SIX</a></p>
<p class="toc-chapter" id="chap-7"><a href="#/BENEATHTHESKIN_chap7">SEVEN</a></p>
<p class="toc-chapter" id="chap-8"><a href="#/BENEATHTHESKIN_chap8">EIGHT</a></p>
<p class="toc-chapter" id="chap-9"><a href="#/BENEATHTHESKIN_chap9">NINE</a></p>
<p class="toc-chapter" id="chap-10"><a href="#/BENEATHTHESKIN_chap10">TEN</a></p>
<p class="toc-chapter" id="chap-11"><a href="#/BENEATHTHESKIN_chap11">ELEVEN</a></p>
<p class="toc-chapter" id="chap-12"><a href="#/BENEATHTHESKIN_chap12">TWELVE</a></p>
<p class="toc-chapter" id="chap-13"><a href="#/BENEATHTHESKIN_chap13">THIRTEEN</a></p>
<p class="toc-part" id="part-2"><a href="#/BENEATHTHESKIN_part2">PART TWO: Jennifer</a></p>
<p class="toc-chapter" id="chap-14"><a href="#/BENEATHTHESKIN_chap14">ONE</a></p>
<p class="toc-chapter" id="chap-15"><a href="#/BENEATHTHESKIN_chap15">TWO</a></p>
<p class="toc-chapter" id="chap-16"><a href="#/BENEATHTHESKIN_chap16">THREE</a></p>
<p class="toc-chapter" id="chap-17"><a href="#/BENEATHTHESKIN_chap17">FOUR</a></p>
<p class="toc-chapter" id="chap-18"><a href="#/BENEATHTHESKIN_chap18">FIVE</a></p>
<p class="toc-chapter" id="chap-19"><a href="#/BENEATHTHESKIN_chap19">SIX</a></p>
<p class="toc-chapter" id="chap-20"><a href="#/BENEATHTHESKIN_chap20">SEVEN</a></p>
<p class="toc-chapter" id="chap-21"><a href="#/BENEATHTHESKIN_chap21">EIGHT</a></p>
<p class="toc-chapter" id="chap-22"><a href="#/BENEATHTHESKIN_chap22">NINE</a></p>
<p class="toc-chapter" id="chap-23"><a href="#/BENEATHTHESKIN_chap23">TEN</a></p>
<p class="toc-chapter" id="chap-24"><a href="#/BENEATHTHESKIN_chap24">ELEVEN</a></p>
<p class="toc-chapter" id="chap-25"><a href="#/BENEATHTHESKIN_chap25">TWELVE</a></p>
<p class="toc-chapter" id="chap-26"><a href="#/BENEATHTHESKIN_chap26">THIRTEEN</a></p>
<p class="toc-chapter" id="chap-27"><a href="#/BENEATHTHESKIN_chap27">FOURTEEN</a></p>
<p class="toc-part" id="part-3"><a href="#/BENEATHTHESKIN_part3">PART THREE: Nadia</a></p>
<p class="toc-chapter" id="chap-28"><a href="#/BENEATHTHESKIN_chap28">ONE</a></p>
<p class="toc-chapter" id="chap-29"><a href="#/BENEATHTHESKIN_chap29">TWO</a></p>
<p class="toc-chapter" id="chap-30"><a href="#/BENEATHTHESKIN_chap30">THREE</a></p>
<p class="toc-chapter" id="chap-31"><a href="#/BENEATHTHESKIN_chap31">FOUR</a></p>
<p class="toc-chapter" id="chap-32"><a href="#/BENEATHTHESKIN_chap32">FIVE</a></p>
<p class="toc-chapter" id="chap-33"><a href="#/BENEATHTHESKIN_chap33">SIX</a></p>
<p class="toc-chapter" id="chap-34"><a href="#/BENEATHTHESKIN_chap34">SEVEN</a></p>
<p class="toc-chapter" id="chap-35"><a href="#/BENEATHTHESKIN_chap35">EIGHT</a></p>
<p class="toc-chapter" id="chap-36"><a href="#/BENEATHTHESKIN_chap36">NINE</a></p>
<p class="toc-chapter" id="chap-37"><a href="#/BENEATHTHESKIN_chap37">TEN</a></p>
<p class="toc-chapter" id="chap-38"><a href="#/BENEATHTHESKIN_chap38">ELEVEN</a></p>
<p class="toc-chapter" id="chap-39"><a href="#/BENEATHTHESKIN_chap39">TWELVE</a></p>
<p class="toc-chapter" id="chap-40"><a href="#/BENEATHTHESKIN_chap40">THIRTEEN</a></p>
<p class="toc-chapter" id="chap-41"><a href="#/BENEATHTHESKIN_chap41">FOURTEEN</a></p>
<p class="toc-chapter" id="chap-42"><a href="#/BENEATHTHESKIN_chap42">FIFTEEN</a></p>
<p class="toc-chapter" id="chap-43"><a href="#/BENEATHTHESKIN_chap43">SIXTEEN</a></p>
<p class="toc-chapter" id="chap-44"><a href="#/BENEATHTHESKIN_chap44">SEVENTEEN</a></p>
<p class="toc-chapter" id="chap-45"><a href="#/BENEATHTHESKIN_chap45">EIGHTEEN</a></p>
<p class="toc-chapter" id="chap-46"><a href="#/BENEATHTHESKIN_chap46">NINETEEN</a></p>
<p class="toc-chapter" id="chap-47"><a href="#/BENEATHTHESKIN_chap47">TWENTY</a></p>
<p class="toc-chapter" id="chap-48"><a href="#/BENEATHTHESKIN_chap48">TWENTY-ONE</a></p>
<p class="toc-chapter" id="chap-49"><a href="#/BENEATHTHESKIN_chap49">TWENTY-TWO</a></p>
<p class="toc-chapter" id="chap-50"><a href="#/BENEATHTHESKIN_chap50">TWENTY-THREE</a></p>
<p class="toc-chapter" id="chap-51"><a href="#/BENEATHTHESKIN_chap51">TWENTY-FOUR</a></p>
<p class="toc-part" id="teas-1"><a href="#/BENEATHTHESKIN_teas1">eBook Special Feature:</a></p>
<p class="toc-chapter" id="teas-2"><a href="#/BENEATHTHESKIN_teas2">A Preview of "KILLING ME SOFTLY"</a></p>
<p class="toc-chapter1" id="teas-3"><a href="#/BENEATHTHESKIN_teas3">ONE</a></p>
<p class="toc-chapter" id="teas-4"><a href="#/BENEATHTHESKIN_teas4">A Preview of "THE RED ROOM"</a></p>
<p class="toc-chapter1" id="teas-5"><a href="#/BENEATHTHESKIN_teas5">1</a></p>
<p class="toc-chapter" id="teas-6"><a href="#/BENEATHTHESKIN_teas6">A Preview of "LAND OF THE LIVING"</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// BENEATHTHESKIN_toc.vue?1a21ee12